<template>
  <div class="container-overlay overlay-form">
    <div class="overlay-message">
      <img src="/ext_files/prepaid/f2g/images/error@2x.png" class="logo-overlay" />
      <div v-if="title === '' || title === undefined" class="title-overlay1">
        <template v-if="locale === 'el_GR'">Ουπς..</template>
        <template v-else>Oops..</template>
      </div>
      <div v-else class="title-overlay1">{{title}}</div>
      <div class="title-overlay2">{{subtitle}}</div>
      <div class="overlay-button-container" v-if="hasCTA == true">
        <a v-on:click="ctaRedirectAction(ctaRedirectionPath)" style="cursor:pointer">
          <div class="button-overlay container-button blue-btn">
                {{ctaTitle}}                           
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import router from '../router/index'

export default {
  name: "Error",
  props: {
    title: String,
    subtitle: String,
    hasCTA: Boolean,
    ctaTitle: String,
    ctaRedirectionPath: String
  },
  data() {
    return {};
  },
  methods: {
    ctaRedirectAction(path) {

      //fallback
      if (path == '' || typeof path == 'undefined') {
        path = '/';
      }

      router.push({
        path: path
      })
    }
  }
};
</script>